export const STATUS_STYLE = {
  met: "bg-emerald-50 text-emerald-600",
  available: "bg-emerald-50 text-emerald-600",
  eligible: "bg-emerald-50 text-emerald-600",
  awarded: "bg-emerald-50 text-emerald-600",
  offer: "bg-emerald-50 text-emerald-600",
  accepted: "bg-emerald-50 text-emerald-700",
  ready_to_review: "bg-emerald-50 text-emerald-700",
  submitted: "bg-sky-50 text-sky-700",
  applied: "bg-sky-50 text-sky-600",
  under_review: "bg-sky-50 text-sky-600",
  decision_pending: "bg-sky-50 text-sky-700",
  draft: "bg-slate-100 text-slate-600",
  preparing: "bg-amber-50 text-amber-700",
  more_information_required: "bg-amber-50 text-amber-700",
  action_needed: "bg-amber-50 text-amber-600",
  requires_update: "bg-amber-50 text-amber-600",
  documents: "bg-amber-50 text-amber-600",
  missing: "bg-rose-50 text-rose-600",
  not_met: "bg-rose-50 text-rose-600",
  declined: "bg-rose-50 text-rose-700",
  withdrawn: "bg-rose-50 text-rose-700",
  closed: "bg-slate-100 text-slate-600",
};

export const STATUS_LABEL = {
  met: "Met", available: "Available", eligible: "Eligible", awarded: "Awarded",
  draft: "Draft", preparing: "Preparing", ready_to_review: "Ready to review",
  submitted: "Submitted", under_review: "Under review",
  more_information_required: "More information required", decision_pending: "Decision pending",
  offer: "Offer received", accepted: "Accepted", declined: "Declined", withdrawn: "Withdrawn", closed: "Closed",
  applied: "Applied", action_needed: "Action needed", requires_update: "Requires Update",
  documents: "Documents needed", missing: "Missing", not_met: "Not met",
};

export const StatusBadge = ({ status, label }) => (
  <span className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-semibold ${STATUS_STYLE[status] || "bg-slate-100 text-slate-600"}`}>
    <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />
    {label || STATUS_LABEL[status] || status}
  </span>
);

export const Card = ({ className = "", children, ...p }) => (
  <div className={`rounded-3xl border border-slate-200 bg-white p-6 shadow-[0_8px_30px_rgba(10,37,64,0.04)] ${className}`} {...p}>
    {children}
  </div>
);
